module.exports = __webpack_public_path__ + "img/standup.2935bb0e.jpg";